<template>
    <TopNav></TopNav>
		<h1>Convertor de temperatură</h1>
		<fieldset>
      <legend>Convertor de temperatură</legend>
      <label for="ce" class="leftLabel">Celsius:</label> <input type="number" v-model.number="celsius" step="any" @input="onCelsiusChange" autofocus id="ce"> <label for="ce">℃</label>
			<br>
      <label for="fa" class="leftLabel">Fahrenheit:</label> <input type="number" v-model.number="fahrenheit" step="any" @input="onFahrenheitChange" id="fa"> <label for="fa">℉</label>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "TemperatureConvertor",
  data() {
    return {
      celsius: 0,
      fahrenheit: 32
    }
  },
  components: {
    TopNav
  },
  methods: {
    onCelsiusChange(e) {
      const celsius = e.currentTarget.value;
      this.fahrenheit = ((celsius * 9) / 5) + 32;
    },
    onFahrenheitChange(e) {
      const fahrenheit = e.currentTarget.value;
      this.celsius = (5 * (fahrenheit - 32)) / 9;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label.leftLabel {
  display: inline-block;
  width: 110px;
}

footer section a {
  margin: 20px;
}
</style>
